const _MASTERDATA_ORDER_FORM_READS = [
  'masterdata.units.view',
  'masterdata.unit_conversions.view',
  'masterdata.seasons.view',
  'masterdata.order_types.view',
  'masterdata.colors.view',
  'masterdata.materials.view',
  'customers.brands.view',
  'masterdata.numbering_rules.view',
  'masterdata.print_templates.view',
  'masterdata.specifications.view'
]
const _MASTERDATA_ORDER_FORM_EDIT_EXTRA = ['masterdata.numbering_rules.edit']
const _MASTERDATA_MATCHING_READS = [
  'masterdata.materials.view',
  'masterdata.colors.view',
  'customers.brands.view'
]

const LEGACY_PERMISSION_ALIASES = {
  'customers.view': ['customers.records.view', 'customers.contacts.view', 'customers.addresses.view'],
  'customers.edit': ['customers.records.edit', 'customers.contacts.edit', 'customers.addresses.edit'],
  'brands.view': ['customers.brands.view'],
  'brands.edit': ['customers.brands.edit'],
  'orders.sales.view': [..._MASTERDATA_ORDER_FORM_READS],
  'orders.sales.edit': [..._MASTERDATA_ORDER_FORM_READS, ..._MASTERDATA_ORDER_FORM_EDIT_EXTRA],
  'orders.material_matching.view': [..._MASTERDATA_MATCHING_READS],
  'orders.material_matching.edit': [..._MASTERDATA_MATCHING_READS],
  'purchase.processing_follow.view': [..._MASTERDATA_MATCHING_READS],
  'orders.view': [
    'orders.sales.view',
    'orders.material_matching.view',
    'orders.dispatch.view',
    'orders.delivery.view',
    'orders.color_confirmation.view'
  ],
  'orders.edit': [
    'orders.sales.edit',
    'orders.material_matching.edit',
    'orders.dispatch.edit',
    'orders.delivery.edit',
    'orders.color_confirmation.edit'
  ],
  'operations.execute': [
    'orders.material_matching.view',
    'orders.material_matching.edit',
    'orders.dispatch.view',
    'orders.dispatch.edit',
    'orders.delivery.view',
    'orders.delivery.edit',
    'orders.color_confirmation.view',
    'orders.color_confirmation.edit'
  ],
  'audit.review': [
    'orders.sales.review',
    'orders.material_matching.review',
    'orders.dispatch.review',
    'orders.delivery.review',
    'orders.color_confirmation.review'
  ],
  'audit.unaudit': ['orders.delivery.unaudit', 'orders.dispatch.unaudit'],
  'material_matching.unaudit': ['orders.material_matching.unaudit'],
  'purchase.orders.view': ['purchase.suppliers.view'],
  'purchase.orders.edit': ['purchase.suppliers.view'],
  'purchase.view': [
    'purchase.suppliers.view',
    'purchase.orders.view',
    'purchase.tracking.view',
    'purchase.processing_follow.view'
  ],
  'purchase.edit': [
    'purchase.suppliers.edit',
    'purchase.orders.edit',
    'purchase.tracking.edit',
    'purchase.processing_follow.view'
  ],
  'purchase.unaudit': ['purchase.orders.unaudit'],
  'inventory.view': ['inventory.records.view', 'inventory.operations.view', 'inventory.material_batches.view', 'inventory.locations.view'],
  // 库位编辑已独立：不再随 inventory.edit 自动获得
  'inventory.edit': ['inventory.records.edit', 'inventory.operations.edit', 'inventory.material_batches.edit'],
  'finance.view': [
    'finance.reconciliation.view',
    'finance.overview.view',
    'finance.monthly_report.view',
    'finance.statement_variance.view',
    'finance.partner_balances.view',
    'finance.partner_ledger.view',
    'finance.vouchers.view',
    'finance.accounts.view',
    'finance.expense_items.view',
    'finance.reimbursement_settings.view',
    'finance.account_balances.view',
    'finance.documents.view',
    'finance.cash_reimbursement.view'
  ],
  'finance.edit': ['finance.documents.edit', 'finance.cash_reimbursement.review'],
  'finance.documents.view': [
    'finance.documents.receipt.view',
    'finance.documents.payment.view',
    'finance.documents.expense.view',
    'finance.documents.advance_receipt.view',
    'finance.documents.advance_payment.view',
    'finance.documents.other_income.view',
    'finance.documents.cash_transfer.view'
  ],
  'billing.statements.view': [
    'billing.statements.receivable.view',
    'billing.payment_footer_accounts.view'
  ],
  'billing.statements.edit': [
    'billing.statements.receivable.edit',
    'billing.payment_footer_accounts.edit'
  ],
  'billing.statements.review': ['billing.statements.receivable.review']
}

const REVERSE_PERMISSION_ALIASES = {
  'customers.records.view': new Set(['customers.view']),
  'customers.records.edit': new Set(['customers.edit']),
  'customers.brands.view': new Set(['brands.view']),
  'customers.brands.edit': new Set(['brands.edit']),
  'orders.sales.view': new Set(['orders.view']),
  'orders.sales.edit': new Set(['orders.edit']),
  // 注意：勿把 delete/unaudit 反向展开成 global.admin，否则持有「反审核」的账号会被当成全站管理员
  'orders.sales.review': new Set(['audit.review']),
  'orders.material_matching.edit': new Set(['operations.execute']),
  'orders.material_matching.review': new Set(['audit.review']),
  'orders.material_matching.unaudit': new Set(['material_matching.unaudit']),
  'orders.dispatch.edit': new Set(['operations.execute']),
  'orders.dispatch.review': new Set(['audit.review']),
  'orders.dispatch.unaudit': new Set(['audit.unaudit']),
  'orders.delivery.edit': new Set(['operations.execute']),
  'orders.delivery.review': new Set(['audit.review']),
  'orders.delivery.unaudit': new Set(['audit.unaudit']),
  'orders.color_confirmation.edit': new Set(['operations.execute']),
  'orders.color_confirmation.review': new Set(['audit.review']),
  'purchase.orders.view': new Set(['purchase.view']),
  'purchase.orders.edit': new Set(['purchase.edit']),
  'purchase.orders.review': new Set(['purchase.edit']),
  'purchase.orders.unaudit': new Set(['purchase.unaudit']),
  'purchase.tracking.view': new Set(['purchase.view']),
  'purchase.tracking.edit': new Set(['purchase.edit']),
  'purchase.tracking.review': new Set(['purchase.edit']),
  'purchase.processing_follow.view': new Set(['purchase.view']),
  'purchase.suppliers.view': new Set(['purchase.view']),
  'purchase.suppliers.edit': new Set(['purchase.edit']),
  'inventory.records.view': new Set(['inventory.view']),
  'inventory.records.edit': new Set(['inventory.edit']),
  'inventory.records.review': new Set(['inventory.edit']),
  'inventory.operations.view': new Set(['inventory.view']),
  'inventory.operations.edit': new Set(['inventory.edit']),
  'inventory.operations.review': new Set(['inventory.edit']),
  'inventory.color_card.batch': new Set(['inventory.edit']),
  'inventory.material_batches.view': new Set(['inventory.view']),
  'inventory.material_batches.edit': new Set(['inventory.edit']),
  'inventory.locations.view': new Set(['inventory.view'])
  // inventory.locations.edit 不反向展开为 inventory.edit（库位编辑独立授权）
}

function expandPermissionKeys(permissionKeys) {
  const keys = new Set(permissionKeys || [])
  let changed = true
  while (changed) {
    changed = false
    const additions = new Set()
    keys.forEach((key) => {
      const legacyAliases = LEGACY_PERMISSION_ALIASES[key] || []
      const reverseAliases = REVERSE_PERMISSION_ALIASES[key] || new Set()
      legacyAliases.forEach((alias) => additions.add(alias))
      reverseAliases.forEach((alias) => additions.add(alias))
    })
    additions.forEach((key) => {
      if (!keys.has(key)) {
        keys.add(key)
        changed = true
      }
    })
  }
  return keys
}

export function collectUserPermissionKeys(user) {
  if (!user) return new Set()
  if (user.is_superuser || user.is_admin) {
    return new Set(['global.admin', '*'])
  }
  const keys = new Set()
  const roles = Array.isArray(user.roles) ? user.roles : []
  for (const role of roles) {
    const perms = Array.isArray(role?.permissions) ? role.permissions : []
    perms.forEach((k) => k && keys.add(k))
  }
  return expandPermissionKeys(keys)
}

export function hasPermission(user, permissionKey) {
  if (!permissionKey) return true
  const keys = collectUserPermissionKeys(user)
  return keys.has('*') || keys.has('global.admin') || keys.has(permissionKey)
}

export function hasAnyPermission(user, ...permissionKeys) {
  return permissionKeys.some((key) => key && hasPermission(user, key))
}

/** 角色上直接勾选的权限（不做 purchase.edit → purchase.orders.edit 等展开） */
export function collectUserRawPermissionKeys(user) {
  if (!user) return new Set()
  const keys = new Set()
  const roles = Array.isArray(user.roles) ? user.roles : []
  for (const role of roles) {
    const perms = Array.isArray(role?.permissions) ? role.permissions : []
    perms.forEach((k) => k && keys.add(k))
  }
  return keys
}

export function hasRawPermission(user, permissionKey) {
  if (!permissionKey) return true
  if (!user) return false
  if (user.is_superuser || user.is_admin) return true
  const raw = collectUserRawPermissionKeys(user)
  return raw.has('*') || raw.has('global.admin') || raw.has(permissionKey)
}

export function hasAnyRawPermission(user, ...permissionKeys) {
  return permissionKeys.some((key) => key && hasRawPermission(user, key))
}

/**
 * 财务/账单模块入口：仅看角色上直接勾选的权限，避免 orders.* 等展开误开财务菜单。
 * finance.view / finance.documents.view 仍作为粗粒度授权（须在角色上勾选）。
 */
export function canAccessFinanceModuleKey(user, permissionKey) {
  if (!permissionKey) return true
  if (!user) return false
  if (user.is_superuser || user.is_admin) return true
  const raw = collectUserRawPermissionKeys(user)
  if (raw.has('*') || raw.has('global.admin') || raw.has(permissionKey)) return true
  if (raw.has('finance.view') && permissionKey.startsWith('finance.')) return true
  if (raw.has('finance.documents.view') && permissionKey.startsWith('finance.documents.')) {
    return true
  }
  if (
    permissionKey === 'billing.payment_footer_accounts.view' &&
    raw.has('billing.statements.view')
  ) {
    return true
  }
  if (
    permissionKey === 'billing.payment_footer_accounts.edit' &&
    raw.has('billing.statements.edit')
  ) {
    return true
  }
  if (permissionKey === 'billing.statements.receivable.view' && raw.has('billing.statements.view')) {
    return true
  }
  if (permissionKey === 'billing.statements.receivable.edit' && raw.has('billing.statements.edit')) {
    return true
  }
  if (
    permissionKey === 'billing.statements.receivable.review' &&
    (raw.has('billing.statements.review') || raw.has('billing.statements.edit'))
  ) {
    return true
  }
  return false
}

/**
 * 是否可查看采购订单/明细中的单价、金额。
 * 仅 purchase.tracking.* 时，展开权限会带上 purchase.orders.edit，但业务上不应看金额，故用「原始角色权限」判断。
 */
export function canViewPurchaseOrderPricing(user) {
  if (!user) return false
  if (user.is_superuser || user.is_admin) return true
  const raw = collectUserRawPermissionKeys(user)
  if (raw.has('*') || raw.has('global.admin')) return true
  if (raw.has('purchase.edit')) return true
  return (
    raw.has('purchase.orders.edit') ||
    raw.has('purchase.orders.review') ||
    raw.has('purchase.orders.unaudit')
  )
}

/** 业务员「我的应收」：按客户归属业务员收紧（看角色直接勾选，不看 finance.view 展开） */
export function shouldScopeReceivablesToOwnCustomers(user) {
  if (!user) return false
  if (user.is_superuser || user.is_admin) return false
  const raw = collectUserRawPermissionKeys(user)
  if (raw.has('finance.view') || raw.has('global.admin')) return false
  return raw.has('finance.receivables.view') || raw.has('mobile.receivables')
}

/** 编辑库存记录（备注、状态等）：与后端 inventory.records.edit / review 一致 */
export function canEditInventoryRecords(user) {
  if (!user) return false
  if (user.is_superuser || user.is_admin) return true
  return (
    hasPermission(user, 'inventory.records.edit') ||
    hasPermission(user, 'inventory.records.review')
  )
}

/** 批量按仓库料号标记色卡 */
export function canBatchColorCard(user) {
  if (!user) return false
  if (user.is_superuser || user.is_admin) return true
  return (
    hasPermission(user, 'inventory.color_card.batch') ||
    canEditInventoryRecords(user) ||
    hasPermission(user, 'inventory.operations.edit') ||
    hasPermission(user, 'inventory.operations.review')
  )
}

/** 期初入库：在库存操作中心发起申请（提交后走审批，不直接入账） */
export function canApplyInitialStockInbound(user) {
  if (!user) return false
  if (user.is_superuser || user.is_admin) return true
  return (
    hasPermission(user, 'inventory.operations.edit') ||
    hasPermission(user, 'inventory.records.edit')
  )
}

/** 期初入库-审批：审核期初申请、批量期初直接入账、下载期初模板等 */
export function canPerformInitialStockInbound(user) {
  if (!user) return false
  if (user.is_superuser || user.is_admin) return true
  return hasPermission(user, 'inventory.initial_stock.review')
}

export function canReviewInitialStockInbound(user) {
  return canPerformInitialStockInbound(user)
}

/** 材料库存：单位成本、库存价值等；须「成本价-查看」或管理员，inventory 编辑权不含此项 */
export function canViewInventoryUnitCost(user) {
  if (!user) return false
  if (user.is_superuser || user.is_admin) return true
  return hasPermission(user, 'pricing.cost.view')
}

/** 账单管理：查看列表与详情（旧 statements.view 仅覆盖应收） */
export function canViewBillingStatements(user, direction = null) {
  if (!user) return false
  if (user.is_superuser || user.is_admin) return true
  const d = String(direction || '').trim().toLowerCase()
  if (d === 'payable') {
    return canAccessFinanceModuleKey(user, 'billing.statements.payable.view')
  }
  if (d === 'receivable') {
    return canAccessFinanceModuleKey(user, 'billing.statements.receivable.view')
  }
  return (
    canAccessFinanceModuleKey(user, 'billing.statements.receivable.view') ||
    canAccessFinanceModuleKey(user, 'billing.statements.payable.view') ||
    canAccessFinanceModuleKey(user, 'billing.statements.view')
  )
}

/** 预付请款 */
export function canViewBillingPrepayment(user) {
  if (!user) return false
  if (user.is_superuser || user.is_admin) return true
  const raw = collectUserRawPermissionKeys(user)
  return (
    raw.has('billing.prepayment.view') ||
    raw.has('billing.statements.view') ||
    raw.has('billing.statements.receivable.view')
  )
}

export function canEditBillingPrepayment(user) {
  if (!user) return false
  if (user.is_superuser || user.is_admin) return true
  const raw = collectUserRawPermissionKeys(user)
  return (
    raw.has('billing.prepayment.edit') ||
    raw.has('billing.statements.edit') ||
    raw.has('billing.statements.receivable.edit')
  )
}

/** 单据中心 */
export function canViewBillingDocumentCenter(user) {
  return canAccessFinanceModuleKey(user, 'billing.document_center.view')
}

/** 收款账户库 */
export function canViewPaymentFooterAccounts(user) {
  if (!user) return false
  if (user.is_superuser || user.is_admin) return true
  return (
    canAccessFinanceModuleKey(user, 'billing.payment_footer_accounts.view') ||
    hasRawPermission(user, 'billing.statements.view') ||
    hasRawPermission(user, 'billing.statements.receivable.view')
  )
}

/** 税票进销库存 */
export function canViewTaxInvoices(user) {
  if (!user) return false
  if (user.is_superuser || user.is_admin) return true
  return (
    canAccessFinanceModuleKey(user, 'billing.tax_invoices.view') ||
    canAccessFinanceModuleKey(user, 'billing.tax_invoices.edit') ||
    canAccessFinanceModuleKey(user, 'billing.tax_invoices.review')
  )
}

export function canEditPaymentFooterAccounts(user) {
  if (!user) return false
  if (user.is_superuser || user.is_admin) return true
  const raw = collectUserRawPermissionKeys(user)
  return (
    raw.has('billing.payment_footer_accounts.edit') ||
    raw.has('billing.statements.edit') ||
    raw.has('billing.statements.receivable.edit')
  )
}

/** 是否显示「财务管理」菜单（任一子模块权限即可） */
export const FINANCE_MENU_VIEW_KEYS = [
  'finance.reconciliation.view',
  'finance.overview.view',
  'finance.monthly_report.view',
  'finance.statement_variance.view',
  'finance.partner_balances.view',
  'finance.partner_ledger.view',
  'finance.vouchers.view',
  'finance.accounts.view',
  'finance.expense_items.view',
  'finance.reimbursement_settings.view',
  'finance.account_balances.view',
  'finance.documents.view',
  'finance.documents.receipt.view',
  'finance.documents.payment.view',
  'finance.documents.expense.view',
  'finance.documents.advance_receipt.view',
  'finance.documents.advance_payment.view',
  'finance.documents.other_income.view',
  'finance.documents.cash_transfer.view',
  'finance.cash_reimbursement.view',
  'finance.receivables.view',
  'billing.statements.view',
  'billing.statements.receivable.view',
  'billing.statements.payable.view',
  'billing.prepayment.view',
  'billing.document_center.view',
  'billing.payment_footer_accounts.view',
  'finance.view'
]

export function canAccessAnyFinanceMenu(user) {
  if (!user) return false
  if (user.is_superuser || user.is_admin) return true
  return FINANCE_MENU_VIEW_KEYS.some((k) => canAccessFinanceModuleKey(user, k))
}

/** 账单管理：新建/编辑草稿、维护明细 */
export function canEditBillingStatements(user, direction = null) {
  if (!user) return false
  if (user.is_superuser || user.is_admin) return true
  const d = String(direction || '').trim().toLowerCase()
  if (d === 'payable') {
    return hasPermission(user, 'billing.statements.payable.edit')
  }
  if (d === 'receivable') {
    return (
      hasPermission(user, 'billing.statements.receivable.edit') ||
      hasPermission(user, 'billing.statements.edit')
    )
  }
  return (
    hasPermission(user, 'billing.statements.edit') ||
    hasPermission(user, 'billing.statements.receivable.edit') ||
    hasPermission(user, 'billing.statements.payable.edit')
  )
}

/** 账单管理：确认账单 */
export function canReviewBillingStatements(user, direction = null) {
  if (!user) return false
  if (user.is_superuser || user.is_admin) return true
  const d = String(direction || '').trim().toLowerCase()
  if (d === 'payable') {
    return (
      hasPermission(user, 'billing.statements.payable.review') ||
      hasPermission(user, 'billing.statements.payable.edit') ||
      hasPermission(user, 'audit.review')
    )
  }
  if (d === 'receivable') {
    return (
      hasPermission(user, 'billing.statements.receivable.review') ||
      hasPermission(user, 'billing.statements.receivable.edit') ||
      hasPermission(user, 'billing.statements.review') ||
      hasPermission(user, 'billing.statements.edit') ||
      hasPermission(user, 'audit.review')
    )
  }
  return (
    hasPermission(user, 'billing.statements.review') ||
    hasPermission(user, 'billing.statements.edit') ||
    hasPermission(user, 'billing.statements.receivable.review') ||
    hasPermission(user, 'billing.statements.receivable.edit') ||
    hasPermission(user, 'billing.statements.payable.review') ||
    hasPermission(user, 'billing.statements.payable.edit') ||
    hasPermission(user, 'audit.review')
  )
}

/** 账单管理：取消确认，将已确认账单恢复为草稿再编辑 */
export function canUnconfirmBillingStatements(user) {
  if (!user) return false
  if (user.is_superuser || user.is_admin) return true
  return hasPermission(user, 'billing.statements.unconfirm')
}

/** 用户权限管理整块：仅管理员 / 超管 / 角色直接勾选 global.admin（不走权限展开） */
export function canManageUsersAndRoles(user) {
  if (!user) return false
  if (user.is_superuser || user.is_admin) return true
  return hasRawPermission(user, 'global.admin')
}

/** 收款单：取消确认恢复草稿（默认仅管理员） */
export function canUnconfirmFinanceDocuments(user) {
  if (!user) return false
  if (user.is_superuser || user.is_admin) return true
  return hasPermission(user, 'finance.documents.unconfirm')
}
